import { white, bdlGray05, bdlGray10, bdlGray, bdlGray30, black, bdlGray40, bdlGridUnitPx, bdlBoxBlue, bdlBoxBlue80 } from './variables.js'; // Copy of https://github.com/box/box-ui-elements/blob/830bf71bef5720a5e6ba128afa35152112674c17/src/styles/theme.js

var theme = {
  base: {
    background: white,
    backgroundHover: bdlGray05,
    backgroundActive: bdlGray10,
    foreground: bdlGray,
    border: bdlGray30,
    buttonForeground: black,
    buttonBackground: white,
    buttonBackgroundHover: bdlGray05,
    buttonBackgroundActive: bdlGray10,
    buttonBorder: bdlGray30,
    buttonBorderHover: bdlGray30,
    buttonBorderActive: bdlGray30,
    progressBarBackground: bdlGray40,
    scrollShadowRgba: 'rgba(0, 0, 0, 0.12)',
    gridUnitPx: parseInt(bdlGridUnitPx, 10),
    // grid unit in pixels (as number for computations)
    dividerBackground: 'rgba(232, 232, 232, 0.1)'
  },
  // Primary or brand color
  primary: {
    background: bdlBoxBlue,
    backgroundActive: '#004eac',
    backgroundGradient: '#0055bc',
    backgroundHover: '#006ae9',
    border: bdlBoxBlue,
    buttonBackground: bdlBoxBlue,
    buttonBackgroundActive: '#004eac',
    buttonBackgroundHover: '#006ae9',
    buttonBorder: bdlBoxBlue,
    buttonBorderActive: '#004eac',
    buttonBorderHover: '#006ae9',
    buttonForeground: white,
    foreground: white,
    progressBarBackground: bdlBoxBlue80,
    scrollShadowRgba: 'rgba(0, 0, 0, 0.12)',
    dividerBackground: 'rgba(232, 232, 232, 0.1)'
  },
  // TODO: Should be the same keys as the default if applicable
  modes: {
    admin: {},
    dark: {}
  }
};
export { theme as default };